<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, computed, useSlots } from 'vue';

/*==================================================================*/
/*================== IMPORTS DE COMPONENTES ========================*/
/*==================================================================*/

import HeaderDaTabela from './HeaderDaTabela/HeaderDaTabela.vue';
import BodyDaTabela from './BodyDaTabela/BodyDaTabela.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    headers: {
        type: Array,
        default: () => []
    },
    dados: {
        type: Array,
        default: () => []
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

/*==================================================================*/
/*================== HEADERS COM ESPACO ============================*/
/*==================================================================*/

const headersComEspaco = computed(() => {

    const headers = [...props.headers];

    headers.unshift({ text: '', value: 'botoes' });
    headers.push({ text: '', value: 'espaco' });

    return headers;

});

/*==================================================================*/
/*================== ESTILO DA TABELA ==============================*/
/*==================================================================*/

const estiloTabela = computed(() => {

    const colunasDeDados = props.headers
        .map((header = {}) => header?.width || 'max-content')
        .join(' ');

    const colunas = `max-content ${colunasDeDados} auto`;

    return { gridTemplateColumns: colunas };

});

const slots = useSlots();

/*==================================================================*/
/*================== SLOTS DE ITEM =================================*/
/*==================================================================*/

const slotsDeItem = computed(() =>

    Object.keys(slots).filter(name => name.startsWith('linha-item.'))

);

</script>

<template>

    <div class="c-tabela-generica__wrapper">

        <div class="c-tabela-generica" :style="estiloTabela">

            <HeaderDaTabela :headers="headersComEspaco"></HeaderDaTabela>

            <BodyDaTabela :headers="headersComEspaco" :dados="props.dados" :disabled="props.disabled">

                <template #linha-botoes="slotProps">

                    <slot name="linha-botoes" v-bind="slotProps"></slot>

                </template>

                <template
                    v-for="name in slotsDeItem"
                    #[name]="slotProps"
                >

                    <slot :name="name" v-bind="slotProps ?? {}"></slot>

                </template>

            </BodyDaTabela>

        </div>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*================== Wrapper da Tabela =============================*/
/*==================================================================*/

.c-tabela-generica__wrapper {
    inline-size: 100%;
    max-inline-size: 100%;
    min-inline-size: 0;
    overflow: auto;
    border: 1px solid #D1D1D1;
    border-radius: 5px;
}

/*==================================================================*/
/*================== Tabela ========================================*/
/*==================================================================*/

.c-tabela-generica {
    display: grid;
    inline-size: max-content;
    min-inline-size: 100%;
}

</style>
